import React, { useContext } from "react";
import { IntlContext } from "context";

/**
 * Avertissements renvoyés par l'API pour la sélection en cours.
 *
 * Ils s'affichent au-dessus des résultats, après les messages déjà présents,
 * et en italique pour les distinguer de ceux-ci.
 */
const Warnings: React.FC<{ warnings?: Array<string> }> = ({ warnings }) => {
    const intl = useContext(IntlContext);

    if (!warnings || warnings.length === 0) {
        return null;
    }

    return (
        <div className="stats-warnings">
            {warnings.map((key: string) => (
                <p key={key} className="stats-warnings__item">
                    {intl.formatMessage(key)}
                </p>
            ))}
        </div>
    );
};

export default Warnings;
